import React from 'react'

import { BrandIconProps } from '../types'
import { SmallSVG } from '../small-svg'

export const KikaIcon = ({ size, small }: BrandIconProps) => (
  <SmallSVG
    size={size}
    small={small}
    viewBox="0 0 88 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="kika-logo" fill="#fff" fillRule="nonzero" transform="translate(0.000000, 41.500000)">
        <path
          d="M87.18,36.01 C86.44,36 85.69,36.07 84.95,35.88 C83.96,35.62 83.13,35.09 82.51,34.27 C82.28,33.97 82.15,33.91 81.8,34.13 C74.9,38.52 65.95,34.89 64.04,26.95 C62.39,20.1 67.15,13.29 74.18,12.53 C76.72,12.25 79.13,12.74 81.35,14.05 C81.58,14.19 81.72,14.29 81.91,13.95 C82.53,12.83 83.52,12.33 84.79,12.51 C85.98,12.68 86.74,13.4 87.08,14.56 C87.09,14.61 87.15,14.64 87.18,14.68 C87.18,21.78 87.18,28.89 87.18,36.01 Z M69.3799727,24.24 C69.3799727,27.6 72.12,30.35 75.46,30.35 C78.79,30.35 81.54,27.58 81.54,24.23 C81.54,20.87 78.79,18.12 75.45,18.12 C72.11,18.12 69.37,20.87 69.3799727,24.24 Z"
          id="Shape"
        ></path>
        <path
          d="M44.7,20.17 C45,20.09 45.1,19.9 45.25,19.76 C49.39,15.6 53.54,11.43 57.68,7.27 C58.36,6.58 58.36,6.58 59.07,7.3 C60.45,8.7 60.82,10.34 60.19,12.2 C59.97,12.84 59.58,13.38 59.1,13.86 C57.11,15.85 55.14,17.85 53.14,19.83 C52.84,20.13 52.85,20.3 53.08,20.63 C56.1,24.86 59.09,29.12 62.11,33.35 C62.41,33.77 62.35,33.92 61.96,34.23 C60.05,35.75 57.9,35.55 56.51,34.66 C55.92,34.28 55.47,33.77 55.07,33.2 C53.07,30.37 51.07,27.56 49.08,24.72 C48.82,24.35 48.68,24.29 48.34,24.65 C47.26,25.78 46.14,26.89 45.03,27.99 C44.79,28.22 44.69,28.46 44.7,28.79 C44.72,30.2 44.71,31.62 44.71,33.03 C44.7,34.76 43.52,36.01 41.91,36.01 C40.3,36.01 39.09,34.75 39.09,33.03 C39.08,29.38 39.09,25.73 39.09,22.08 C39.09,15.75 39.09,9.42 39.09,3.1 C39.09,1.56 39.87,0.46 41.18,0.1 C42.93,-0.38 44.67,0.88 44.71,2.69 C44.75,4.31 44.72,5.94 44.72,7.57 C44.72,11.57 44.72,15.56 44.72,19.56 C44.7,19.73 44.7,19.92 44.7,20.17 Z"
          id="Path"
        ></path>
        <path
          d="M6.67,20.21 C7.14,19.72 7.6,19.22 8.08,18.73 C11.98,14.81 15.89,10.9 19.77,6.96 C20.13,6.6 20.29,6.68 20.61,6.99 C22.08,8.4 22.65,10.04 22.05,12.03 C21.83,12.76 21.39,13.36 20.86,13.89 C18.93,15.83 17.02,17.78 15.06,19.7 C14.65,20.1 14.68,20.34 14.99,20.77 C17.98,24.95 20.94,29.16 23.93,33.34 C24.23,33.76 24.16,33.92 23.78,34.21 C22.55,35.14 21.23,35.56 19.7,35.21 C18.56,34.95 17.69,34.31 17.02,33.37 C14.98,30.48 12.93,27.6 10.9,24.71 C10.64,24.34 10.5,24.29 10.16,24.64 C9.08,25.77 7.96,26.88 6.84,27.98 C6.62,28.2 6.53,28.42 6.53,28.73 C6.55,30.16 6.54,31.6 6.54,33.03 C6.53,34.74 5.33,36.01 3.72,36.01 C2.11,36.01 0.91,34.74 0.91,33.03 C0.91,23.01 0.91,12.99 0.91,2.98 C0.91,1.26 2.11,-7.10542736e-15 3.72,-7.10542736e-15 C5.33,-7.10542736e-15 6.54,1.26 6.54,2.98 C6.54,8.49 6.54,13.99 6.54,19.5 C6.54,19.71 6.54,19.92 6.54,20.13 C6.58,20.14 6.63,20.17 6.67,20.21 Z"
          id="Path"
        ></path>
        <path
          d="M28.34,25.16 C28.34,22.5 28.33,19.85 28.35,17.19 C28.36,15.81 29.24,14.72 30.51,14.44 C32.33,14.04 33.96,15.35 33.97,17.27 C33.99,19.85 33.97,22.43 33.97,25.01 C33.97,27.7 33.98,30.4 33.97,33.09 C33.97,34.4 33.21,35.47 32.04,35.86 C30.92,36.24 29.7,35.87 28.95,34.93 C28.5,34.37 28.34,33.72 28.34,33.01 C28.34,30.4 28.34,27.78 28.34,25.16 C28.34,25.16 28.34,25.16 28.34,25.16 Z"
          id="Path"
        ></path>
        <path
          d="M28.34,9.4 C28.34,7.84 29.58,6.58 31.12,6.57 C32.67,6.56 33.97,7.85 33.96,9.41 C33.95,10.97 32.65,12.26 31.1,12.24 C29.57,12.23 28.34,10.96 28.34,9.4 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </SmallSVG>
)

KikaIcon.defaultProps = {
  size: {
    width: 88,
    height: 120,
  },
}
